export const popups: Record<string, string> = {
	popup_recharging: "Recharging",
	popup_jetpack_noSafeSpot: "No safe spot to land",
};
